// Imports
var ___HTML_LOADER_IMPORT_0___ = require("/src/images/graphics/graphic-equation-info.png");
// Module
var code = `<template> <div class="dialog-equation-graphic dialog-wrap"> <div class="dialog-header"> <div class="row justify-content-end col-gutter"> <comp-icon class="icon-close" icon="close" click.trigger="close()"></comp-icon> </div> </div> <div class="dialog-content"> <img class="equation" src="${___HTML_LOADER_IMPORT_0___}"/> </div> </div> </template>`;
// Exports
module.exports = code;